import { GetServerSideProps, GetServerSidePropsContext } from "next";

export const getServerSideProps: GetServerSideProps = async (
    context: GetServerSidePropsContext
) => {
    const { uniqueLink } = context.params as { uniqueLink: string };

    context.res.writeHead(302, { Location: `/${uniqueLink}/home` });
    context.res.end();

    return { props: {} };
};

const IndexPage = () => {
    return null;
};

export default IndexPage;
